import React from "react";

const NotFound = () => {
  return (
    <div className="not-found">
      <h1>404: Not Found</h1>
      <p>La página que buscas no existe.</p>
    </div>
  );
};

export default NotFound;

